import { BLOCK_LIST_OL, BLOCK_LIST_TASKS, BLOCK_LIST_UL } from '@gitbook/doc-core';
import { PaletteCommandType } from '@gitbook/react-uikit';
import { useEditor } from '@gitbook/slate-react';
import { Icon } from '@gitbook/spine-icons';

import { useBlockPaletteFactory } from '../common';

/**
 * Hook to use a commands palette definition to edit a list item block.
 */
export function useListItemBlockPaletteFactory(input: { nodeKey: string }) {
    const { nodeKey } = input;
    const editor = useEditor();
    return useBlockPaletteFactory({
        nodeKey,
        createExtraGroups: () => {
            return [
                {
                    key: 'list',
                    commands: () => {
                        const parent = editor.value.document.getParent(nodeKey);

                        if (!parent) {
                            return [];
                        }

                        return [
                            {
                                key: 'ul',
                                type: PaletteCommandType.CHECKBOX,
                                title: 'Unordered list',
                                icon: Icon.ListUnordered,
                                selected: parent.type === BLOCK_LIST_UL,
                                trigger: () => {
                                    editor.change((change) => {
                                        change.setNodeByKey(parent.key, {
                                            type: BLOCK_LIST_UL,
                                        });
                                    });
                                },
                            },
                            {
                                key: 'ol',
                                type: PaletteCommandType.CHECKBOX,
                                title: 'Ordered list',
                                icon: Icon.ListOrdered,
                                selected: parent.type === BLOCK_LIST_OL,
                                trigger: () => {
                                    editor.change((change) => {
                                        change.setNodeByKey(parent.key, {
                                            type: BLOCK_LIST_OL,
                                        });
                                    });
                                },
                            },
                            {
                                key: 'tasks',
                                type: PaletteCommandType.CHECKBOX,
                                title: 'Tasks list',
                                icon: Icon.ListTasks,
                                selected: parent.type === BLOCK_LIST_TASKS,
                                trigger: () => {
                                    editor.change((change) => {
                                        change.setNodeByKey(parent.key, {
                                            type: BLOCK_LIST_TASKS,
                                        });
                                    });
                                },
                            },
                        ];
                    },
                },
            ];
        },
        aiCompletion: true,
    });
}
